<template>
  <jade-box
    class="flex-1"
    :title="$t('others.title')"
    hasPadding
  >
    <template #action>
      <jade-tooltip
        v-if="showTooltip"
        :text="computedTooltip"
        placement="top-start"
      >
        <jade-icon
          use="circle-info"
          size="small"
        />
      </jade-tooltip>
    </template>
    <template>
      <div class="flex flex-col gap-2">
        <jade-text variant="heading-small">R$ {{ data.value }}</jade-text>
        <div>
          <jade-text>{{ computedText.label }}</jade-text>
          <jade-text>{{ computedText.percentage }}</jade-text>
        </div>
      </div>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeTooltip, JadeIcon, JadeText } from '@jade'
import TransactionStatusManager from './transaction-status.manager'

export default {
  name: 'TransactionStatusOthers',

  components: {
    JadeBox,
    JadeText,
    JadeTooltip,
    JadeIcon
  },

  props: {
    data: Object
  },

  computed: {
    computedText () {
      const label = this.$tc('others.sales', this.data.quantity)
      return TransactionStatusManager.getFormatedLabelAndPercentage(
        this.data,
        label
      )
    },
    computedTooltip () {
      const items = this.data.tooltip?.map(item => {
        const label = this.$tc('others.sales', item.quantity)
        const tooltipKey = this.$t(`others.tooltip.${item.name}`)
        const valueText = `${tooltipKey}: R$ ${item.value} | ${item.quantity} ${label}.`

        return valueText
      })

      return items.join('\n')
    },
    showTooltip () {
      return this.data.tooltip?.length
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "others": {
        "title": "Outros",
        "description": "Cobranças que foram autorizadas e depois canceladas.",
        "sales": "cobrança | cobrança | cobranças",
        "tooltip": {
          "awaitingPayment": "Aguardando pagamento",
          "authorized": "Autorizada",
          "inReview": "Em análise",
          "reversalPending": "Estorno pendente",
          "processing": "Processando",
          "revisionPending": "Revisão pendente",
          "chargedback": "Chargeback"
        }
      }
    },
    "en-US": {
      "others": {
        "title": "Others",
        "description": "Charges that have been authorized/captured and then canceled.",
        "sales": "charge | charge | charges",
        "tooltip": {
          "awaitingPayment": "Awaiting Payment",
          "authorized": "Authorized",
          "inReview": "In Review",
          "reversalPending": "Reversal pending",
          "processing": "Processing",
          "revisionPending": "Revision Pending",
          "chargedback": "Chargeback"
        }
      }
    }
  }
  </i18n>
